import type { InsightsEvent } from 'search-insights';

export const createHitViewEvent = ({
  indexName,
  objectIDs,
}: {
  indexName: string;
  objectIDs: string[];
}): InsightsEvent => {
  return {
    eventType: 'view',
    index: indexName,
    eventName: 'Hits Viewed',
    objectIDs,
  };
};

export const createHitClickEvent = ({
  indexName,
  objectID,
  queryID,
}: {
  indexName: string;
  objectID: string;
  queryID: string;
}): InsightsEvent => {
  return {
    eventType: 'conversion',
    index: indexName,
    eventName: 'Hit Converted',
    objectIDs: [objectID],
    queryID,
  };
};
